
import { defineComponent, ref } from 'vue'
import { CommonService } from '@/api/common'
export default defineComponent({
  name: 'header',
  setup() {
    const friendList = ref([])
    const getFriendList = async () => {
      const params = {}
      const res = await CommonService.getFriendList(params)
      friendList.value = res.data.data
    }
    getFriendList()
    return {
      friendList
    }

  },
})
